import PropTypes from "prop-types";

import LinksList from "@/components/Elements/LinksList";
import { useModelLink } from "@/modules/model-link";

import { AssetTypeType } from "./AssetType.type";

const AssetTypesLinksList = ({ assetTypes }) => {
  const { getModelLink } = useModelLink();

  const links = assetTypes?.map((assetType) => ({
    label: assetType.name,
    to: getModelLink("assettype", assetType),
  }));

  return <LinksList links={links} />;
};

AssetTypesLinksList.propTypes = {
  assetTypes: PropTypes.arrayOf(AssetTypeType),
};

export default AssetTypesLinksList;
